export const SET_COOKIES = 'SET_COOKIES'
export const OPEN_COOKIES_MODAL = 'OPEN_COOKIES_MODAL'

export const COOKIE_TYPE_PREFERENCE = 'visitPreferences'
export const COOKIE_TYPE_ANALYTICS = 'analytics'
